import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth";
import consulteeReducer from './consultee';
import generalReducer from './general';
import messageReducer from './message';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    consultee: consulteeReducer,
    general: generalReducer,
    message: messageReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
